import * as React from 'react';

import * as styles from './FilterPriceWrapper.css';

export const FilterPriceWrapper = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
